export const convertStringBoolToBoolean = (value: any) => {
  const stringValue = value != null ? String(value) : null;
  if (stringValue === 'true') return true;
  if (stringValue === 'false') return false;
  return null;
};
